import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=60101792&scoped=true"
import script from "./IconClose.vue?vue&type=script&lang=ts"
export * from "./IconClose.vue?vue&type=script&lang=ts"
import style0 from "./IconClose.vue?vue&type=style&index=0&id=60101792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60101792",
  null
  
)

export default component.exports